// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1___5c0b99178406cf883b8","cls2":"PaperSelector-cls2___fae28fdf1b5c80e036c PaperSelector-cls1___5c0b99178406cf883b8"};